import { API } from '@/api';
import axios from 'axios';

const state = {
  recibo: '',
};
const getters = {
  getRecibo: (State) => {
    if (state.recibo) {
      return state.recibo;
    } else if (typeof window.sessionStorage.getItem('recibo') === 'string') {
      return JSON.parse(window.sessionStorage.getItem('recibo') || '{}');
    } else {
      console.error('Error parsing window.sessionStorage.getItem("recibo")');
      return JSON.parse('{}');
    }
  },
};

const actions = {
  async getRecibosList({ commit, State }, {condo, admin, options}) {
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    const response = await API.get('/recibos/list/' + admin.id + '/' + condo.id, {params: queryString});
    return response.data;
  },
  async getRecibosList2({ commit, State }, {condo, admin, options}) {
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    const response = await API.get('/recibos/list2/' + admin.id + '/' + condo.id, {params: queryString});
    return response.data;
  },
  async getReciboById({ commit, State }, {condo, admin, recibo}) {
    const response = await API.get('/recibos/get/' + admin.id + '/' + condo.id + '/' + recibo.id);
    return response.data;
  },
  async addRecibo({ commit, State }, {datos}) {
    const response = await API.post('/recibos/add/' + datos.administracion.id + '/' + datos.condominio.id, datos);
    return response;
  },
  async addNotaCredito({ commit, State }, {datos}) {
    console.log('Paso por aqui');
    const response = await API.post('/notac/add/' + datos.administracion.id
        + '/' + datos.condominio.id + '/' + datos.idRecibo, datos);
    return response;
  },
  async deleteBorrador({ commit, State }, {admin, condo, recibo}) {
    const response = await API.delete('/recibos/delete/draft/' + admin.id + '/' + condo.id + '/' + recibo.id);
    return response;
  },
  async generarReporteMes({commit, State}, {admin, condo}) {
    const response = await API.post('/reporte/mes/generar/' + admin.id + '/' + condo.id);
    return response.data;
  },
  async generarRecibo({ commit, State }, {plantilla, admin, condo, recibo}) {
    const response = await API.post('/reportes/recibo/multi/generar/' + admin.id + '/' + condo.id,
      recibo);
    return response.data;
  },
  async generarAviso({ commit, State }, {plantilla, admin, condo, recibo}) {
    const response = await API.post('/reportes/recibo/recordatorio/multi/generar/' + admin.id + '/' + condo.id,
      recibo);
    return response.data;
  },
  async multiRecibos({ commit, State }, {admin, condo, recibos}) {
    const response = await API.post('/recordatorios/crear/' + admin.id + '/' + condo.id, recibos);
    return response.data;
  },
  async sendRecibo({ commit, State }, {admin, condo, recibo}) {
    const response = await API.get('/reportes/recibo/enviar/recibo/' + admin.id + '/' + condo.id
      + '/' + recibo);
    return response.data;
  },
  async sendAviso({ commit, State }, {admin, condo, recibo}) {
    const response = await API.get('/reportes/recibo/enviar/aviso/' + admin.id + '/' + condo.id
      + '/' + recibo);
    return response.data;
  },
  async addCobro({ commit, State }, {datos}) {
    const response = await API.post(`/${datos.admin.id}/${datos.condo.id}/cobro/simple/${datos.recibo.id}`,
     datos.cobro);
    return response;
  },
  async addCobroItem({ commit, State }, {datosIngreso}) {
    const response = await API.post(`/${datosIngreso.admin.id}/${datosIngreso.condo.id}/cobro/simple/items/${datosIngreso.recibo.id}`,
    datosIngreso.cobro);
    return response;
  },
  async getCobroList({ commit, State }, {admin, condo, options}) {
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    const response = await API.get(`/${admin.id}/${condo.id}/cobro/list`, {params: queryString});
    return response.data;
  },
  async findUnidades({ commit, State }, {admin, condo, options, filters}) {
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    const response = await API.post('/recibos/find/' + admin.id + '/' + condo.id, filters, {params: queryString});
    return response.data;
  },
/*
  async findRecibosPeriodo({ commit, State }, {admin, condo, req}) {
      return API.post('/recibos/find/periodo/' + admin.id + '/' + condo.id, req)
      .then((response) => response.data )
      .then((response) => {response.forEach((recibo, idx) => recibo.unidad.saldo = 0 );
                           return response; });
  },
*/
  async findReportesPeriodo({ commit, State }, {admin, condo, req}) {
      const response = API.post('/reportes/find/periodo/' + admin.id + '/' + condo.id, req);
      return response;
  },
  async findReportesPeriodo2({ commit, State }, {admin, condo, req}) {
      const response = API.post('/reportes/find2/periodo/' + admin.id + '/' + condo.id, req);
      return response;
  },
  async findReciboId({ commit, State }, {datos}) {
    // console.log("pasoXaqui", admin, condo);
    const response = API.post(`/recibos/findId/${datos.admin}/${datos.condo}/${datos.reciboId}`);
    return response;
  },
  async getFile({ commit, State }, {adm, cond}) {
    const response = await API.get(`/recibos/getcsv/${adm.id}/${cond.id}`);
    return response;
  },
  async sendFile({ commit, State }, {adm, cond, req}) {
    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    const formData = new FormData();
    formData.append('title', req.titulo);
    formData.append('file', req.archivoCSV);
    formData.append('descripcion', req.descripcion);
    formData.append('type', req.tipoDeComprobante);
    formData.append('fechaEmision', req.fechaDeEmision);
    formData.append('serie', req.serie);
    formData.append('periodo', req.periodo);
    const response = await API.post(`/recibos/sendcsv/${adm.id}/${cond.id}`, formData, {headers});
    return response;
  },
  setRecibo({ commit, State }, recibo) {
    commit('setRecibo', recibo);
  },
  async updateStatusRecibo({ commit, State }, {admin, condo, recId}) {
    const response = await API.post(`/recibos/update/status/${admin.id}/${condo.id}/${recId}`);
    return response;
  },
  async getStatusRecibo({ commit, State }, {admin, condo, reciboId}) {
    const response = await API.get(`/recibos/get/status/${admin}/${condo}/${reciboId}`);
    return response;
  },
};
const mutations = {
  setRecibo: (State, recibo) => {
      State.recibo = recibo;
      window.sessionStorage.setItem('recibo', JSON.stringify(recibo));
  },
};

export default {
  actions,
  getters,
  mutations,
  state,
};
